module.exports = __webpack_public_path__ + "img/new.ea492d93.jpg";